module.exports = __webpack_public_path__ + "static/media/+.76192731.svg";